module.exports = __webpack_public_path__ + "img/Personalmanagementselect.cb0af8c6.svg";